export const assertNever = (type: never) => {
  throw new Error(`assertNever: ${type}`);
};
